<template>
    <div>页面飞了</div>
</template>
